import sendRequest from '../client/sendRequest';

const BASE_URL = '/api/staff';

//Get all staff information
export async function getAllStaff() {
  return await sendRequest(BASE_URL, 'GET');
}

//Create a staff
export async function postStaff(data) {
  return await sendRequest(BASE_URL, 'POST', data);
}

//Edit a staff
export async function editStaff(id, data) {
  return await sendRequest(`${BASE_URL}/${id}`, 'PUT', data);
}

//Delete a staff
export async function deleteStaff(id) {
  return await sendRequest(`${BASE_URL}/${id}`, 'DELETE');
}
